import { Plus, Trash2 } from "lucide-react";

const ACCENT = "#4fb3a4";
const inputCls = "rounded-md px-3 py-2 text-sm text-white outline-none";
const inputStyle = { backgroundColor: "#0a0e12", border: "1px solid #28323e" };

export const SecurestSundries = ({ rows, setRows }) => {
  const update = (i, key, val) => setRows((rs) => rs.map((r, j) => (j === i ? { ...r, [key]: val } : r)));
  const remove = (i) => setRows((rs) => rs.filter((_, j) => j !== i));
  const add = () => setRows((rs) => [...rs, { description: "", qty: 1, unit_price: "" }]);

  return (
    <div className="mt-6 pt-6 border-t" style={{ borderColor: "#1c2530" }} data-testid="securest-sundries">
      <div className="text-sm font-semibold text-white mb-1">Sundry parts</div>
      <div className="text-xs mb-3" style={{ color: "#64748b" }}>Add any extra items (cable, fixings, labour…) with your unit price.</div>
      {rows.length > 0 && (
        <div className="space-y-2 mb-3">
          {rows.map((r, i) => (
            <div key={i} className="grid grid-cols-12 gap-2 items-center" data-testid={`securest-sundry-row-${i}`}>
              <input data-testid={`securest-sundry-desc-${i}`} placeholder="Description" value={r.description}
                onChange={(e) => update(i, "description", e.target.value)} className={`${inputCls} col-span-12 sm:col-span-7`} style={inputStyle} />
              <input data-testid={`securest-sundry-qty-${i}`} type="number" min="1" placeholder="Qty" value={r.qty}
                onChange={(e) => update(i, "qty", e.target.value)} className={`${inputCls} col-span-4 sm:col-span-2`} style={inputStyle} />
              <input data-testid={`securest-sundry-price-${i}`} type="number" min="0" step="0.01" placeholder="Unit £" value={r.unit_price}
                onChange={(e) => update(i, "unit_price", e.target.value)} className={`${inputCls} col-span-6 sm:col-span-2`} style={inputStyle} />
              <button type="button" data-testid={`securest-sundry-remove-${i}`} onClick={() => remove(i)}
                className="col-span-2 sm:col-span-1 flex justify-center text-slate-500 hover:text-red-400 transition-colors">
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      )}
      <button type="button" data-testid="securest-sundry-add" onClick={add}
        className="text-xs px-3 py-1.5 rounded border flex items-center gap-1 transition-colors hover:bg-white/5" style={{ borderColor: ACCENT, color: ACCENT }}>
        <Plus className="h-3.5 w-3.5" /> Add sundry item
      </button>
    </div>
  );
};
